import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'rcp-section-container',
  template: `<ng-content />`,
  styles: `
    :host {
      &.grid {
        display: grid;
        gap: var(--section-padding);
        /* This makes sure the columns in the grid are all equally distributed */
        grid-template-columns: repeat(auto-fit, minmax(var(--min-section-width), 1fr));
      }
      &.default {
        display: flex;
        flex-direction: column;
        gap: var(--section-spacing-between);
        flex-grow: 1;
      }
    }
  `,
  host: {
    '[class]': 'type()',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SectionContainerComponent {
  type = input<'default' | 'grid'>('default');
}
